module.exports = __webpack_public_path__ + "hair-summary-fef065.svg";